export default function ArticleCTA() {
  return (
    <section className="w-full py-14 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            Start Your LitBuy Journey
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 leading-relaxed">
            Ready to put your <strong>LitBuy spreadsheet</strong> knowledge into action? Explore thousands of products across 14 categories and start making smarter shopping decisions today.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-foreground-950 text-background-50 text-base font-semibold whitespace-nowrap cursor-pointer hover:bg-foreground-800 hover:scale-105 transition-all duration-300"
            >
              buy it now
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="/"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border-2 border-foreground-300 text-foreground-700 text-base font-semibold whitespace-nowrap cursor-pointer hover:border-primary-400 hover:text-primary-500 transition-all duration-200"
            >
              <i className="ri-home-4-line"></i>
              Back to Home
            </a>
          </div>

          <div className="mt-10 flex flex-wrap justify-center gap-3">
            {['Shoes', 'Hoodies', 'T-Shirts', 'Jackets', 'Bags', 'Accessories', 'Jersey', 'Sets'].map((item) => (
              <div
                key={item}
                className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-background-100 overflow-hidden flex items-center justify-center"
              >
                <i className="ri-shopping-bag-line text-lg text-foreground-400"></i>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}